import React from 'react';
import PropTypes from 'prop-types';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Tooltip } from '@mui/material';

import icon from './iconStyles.module.css';

const OnFileDownloadIcon = ({ onDownload, active = true }) => {
    const onClickIcon = (e) => {
        e.stopPropagation();
        active && onDownload();
    };

    return (
        <div
            className={`${icon.downloadIcon} ${!active ? icon.disabled : ''}`}
            onClick={onClickIcon}
            data-testid="download_icon_wrapper">
            <Tooltip title="Download" placement="top" disableHoverListener={!active}>
                <FileDownloadIcon
                    aria-label="file-download-icon"
                    data-testid="file-download-icon"
                />
            </Tooltip>
        </div>
    );
};

OnFileDownloadIcon.propTypes = {
    active: PropTypes.bool,
    onDownload: PropTypes.func
};

export default OnFileDownloadIcon;
